<template>
  <div>
    <div class="form-check">
      <input type="checkbox" v-model="detail.no_use.value" class="form-check-input" id="ch1">
      <label class="form-check-label" for="ch1">Безрецептурный (ОТС)</label>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="">Название на латыни</label>
          <input :disabled="!!detail.no_use.value" class="form-control" type="text"
                 v-model="detail.lt_title.value"/>
        </div>
        <div class="form-group">
          <label for="">Применение (Signa)</label>
          <input :disabled="!!detail.no_use.value" class="form-control" type="text"
                 v-model="detail.signa.value"/>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Кол. уп. в рецепте</label>
          <input :disabled="!!detail.no_use.value" class="form-control" type="text"
                 v-model="detail.pack.value"/>
        </div>
        <div class="form-group">
          <label for="">На сколько дней рецепт</label>
          <input :disabled="!!detail.no_use.value" class="form-control" type="text"
                 v-model="detail.days.value"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detail']
}
</script>
